import { memo } from 'react';

import { makeStyles } from '@material-ui/styles';
import { Theme } from '../../../theme';

import { ttCommons600 } from './fonts';
import { isDesktop } from '@overrided-vkui';

const useStyles = makeStyles<Theme, { isDesktop: boolean }>({
  '@global': {
    // Add TT Commons font family
    '@font-face': [
      {
        fontFamily: 'TT Commons',
        fontStyle: 'normal',
        fontWeight: 600,
        src: `url("${ttCommons600}") format("woff2")`,
      },
    ],
    // Set body and #root defaults
    body: {
      overflowX: 'hidden',
      userSelect: 'none',
      '-webkit-font-smoothing': 'antialiased',
      '-webkit-tap-highlight-color': 'transparent',
      '-webkit-text-size-adjust': '100%',
      '-webkit-overflow-scrolling': 'touch',
    },
    '#root': {
      height: '100%',
    },
    'body, #root': {
      margin: 0,
      padding: 0,
    },
    '.Separator__in, .ModalPageHeader__shadow::after': {
      height: 0.5,
    },
    '.Search__after': {
      bottom: 0,
    },
    // Global desktop color overrides
    'html body': ({ isDesktop }) =>
      isDesktop && {
        '--safe-area-inset-top': '0px',
        '--panelheader_height_ios': '48px',
        '--panelheader_height_android': '48px',
        '&:not([scheme=space_gray])': {
          '--accent': 'var(--blue_400)',
          '--text_placeholder': 'var(--gray_500)',
          '--destructive': 'var(--red)',
        },
        '& #root': {
          userSelect: 'text!important',
        },
      },
  },
});

/**
 * Component which controls global styles
 * @type {React.NamedExoticComponent<object>}
 */
const GlobalStyleSheet = memo(() => {
  useStyles({ isDesktop });
  return null;
});

export default GlobalStyleSheet;
